import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59e7e5c9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "toggleWrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "typeToggle" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-color" }, "Trailer number contains letters", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      type: "checkbox",
      name: "typeToggle",
      class: "mobileToggle",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.hasLetters) = $event)),
      id: "typeToggle"
    }, null, 512), [
      [_vModelCheckbox, _ctx.hasLetters]
    ]),
    _hoisted_2,
    _hoisted_3
  ]))
}